import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=afb61f80&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jonas/Projects/Risolto/operator-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('afb61f80')) {
      api.createRecord('afb61f80', component.options)
    } else {
      api.reload('afb61f80', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=afb61f80&", function () {
      api.rerender('afb61f80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/_credit_notes/detail.vue"
export default component.exports